import * as $ from "jquery";
import * as Backbone from "backbone";
import * as _ from "underscore";
import * as Marionette from "backbone.marionette";
import { on, Options } from "../utils/decorators";

@Options({
    template: false,
    ui: {
        links:"a"
    }
})
export default class NewWindowView extends Marionette.View<Backbone.Model>{

    onRender(){
        this.ui.links.each(function(i, obj){
            $(obj).attr("target", "_blank");
        });
    }    
}



// WEBPACK FOOTER //
// ./@modules/views/new-window-view.ts